import { ROUTES } from 'pages/routes';
import {
  XLogo,
  InstagramIcon,
  DiscordIcon,
  RedditIcon,
  YouTubeIcon,
  FacebookIcon,
  LinkedInIcon,
  WhatsAppIcon,
  NRGTokenIcon,
  ETHTokenIcon,
  USDTTokenIcon,
  USDCTokenIcon,
  DAITokenIcon,
  PEPETokenIcon,
  // ARCHIVED Season 14: Tweet To Earn Icon (temporarily removed — easy to bring back)
  // XAirdropIcon,
  // ARCHIVED: Liquidity Airdrop Icon - Season 11
  // LiquidityAirdropIcon,
  // ARCHIVED: Creator Airdrop Icon - Season 11
  // CreatorAirdropIcon,
  TraderAirdropIcon,
  // HIDDEN: Token Hodler Airdrop Icon (hidden from UI)
  // TokenAirdropIcon,
  // ARCHIVED: NFT Hodler Icon - Season 12 (will re-add later)
  // NftAirdropIcon,
  LeaderboardsIcon,
  BoostersIcon,
  ZealyAirdropIcon,
  // ARCHIVED: Marketplace Volume Airdrop Icon - Season 11
  // NftVolumeAirdropIcon,
  // NftBridingAirdropIcon,  // TODO: Uncomment when NFT Bridging Program is active again
  // ARCHIVED: Portfolio Airdrop Icon - Season 12
  // NftPortfolioAirdropIcon,
  NftListingAirdropIcon,
  // ARCHIVED: Power Tweet Airdrop Icon - Season 11
  // PowerTweetAirdropIcon,
  //MemeCreatorIcon, hide for now
  ReferralContestIcon,
  DailyCheckIcon,
  RewardsVaultIcon,
  EasyWinsIcon,
  PowerUserProgramsIcon,
  Cash2Icon,
} from 'components/ImageComponent';
import {
  // ARCHIVED: Creator Airdrop DataRow - Season 11
  // CreatorDataRow,
  // ARCHIVED: Liquidity Airdrop DataRow - Season 11
  // LiquidityDataRow,
  // ARCHIVED: NFT Hodler DataRow - Season 12 (will re-add later)
  // NftHodlerDataRow,
  // HIDDEN: Token Hodler Airdrop DataRow (hidden from UI)
  // TokenHodlerDataRow,
  TraderDataRow,
  // ARCHIVED Season 14: Tweet To Earn DataRow (temporarily removed — easy to bring back)
  // XDataRow,
  // ARCHIVED: Marketplace Volume Airdrop DataRow - Season 11
  // NftVolumeDataRow,
  ZealyDataRow,
  // ARCHIVED: Portfolio Airdrop DataRow - Season 12
  // NftPortfolioDataRow,
  MintingDataRow,
  // ARCHIVED: Power Tweet Airdrop DataRow - Season 11
  // PowerTweetDataRow,
  ListingDataRow,
  ReferralContestDataRow,
} from 'pages/Leaderboard/components/Table';

// Login
export const SIGNATURE_EXPIRY_TIME = 7 * 24 * 60 * 60 * 1000; // 7 days
export const AUTH_MESSAGE_TO_SIGN = (address, nonce) => {
  return `Welcome to GMI!\n\nClick to sign in and accept the GMI Terms of Service\n\nThis request will not trigger a blockchain transaction or cost any gas fees.\n\nYour authentication status will reset after 7 days.\n\nWallet address: ${address}\n\nNonce: ${nonce}`;
};

// Social Media
export const SOCIAL_MEDIAS = [
  {
    name: 'Twitter',
    link: 'https://x.com/energi',
    icon: <XLogo />,
  },
  {
    name: 'Instagram',
    link: 'https://www.instagram.com/energicrypto',
    icon: <InstagramIcon />,
  },
  {
    name: 'Discord',
    link: 'https://discord.com/invite/sCtgNC3/',
    icon: <DiscordIcon />,
  },
  {
    name: 'Reddit',
    link: 'https://www.reddit.com/r/energicryptocurrency/',
    icon: <RedditIcon />,
  },
  {
    name: 'Youtube',
    link: 'https://www.youtube.com/c/Energicrypto',
    icon: <YouTubeIcon />,
  },
];
export const SOCIAL_LINKS = {
  DiscordEnergi: 'https://discord.com/invite/sCtgNC3',
  DiscordDD: 'https://discord.gg/6nU4zyNxyH',
  TwitterDD: 'https://x.com/DragonDegensNFT',
  TwitterGMI: 'https://x.com/gonnamakeitnfts',
  TwitterEnergi: 'https://x.com/energi',
  TwitterTommy: 'https://x.com/TommyWorldPower',
  TwitterRyan: 'https://x.com/ryanlucchese',
  Telegram: 'https://t.me/GonnaMakeitNFTs',
};
export const SOCIAL_MEDIA_SHARE_INFO = [
  {
    name: 'X(Twitter)',
    background: '#FFFFFF',
    hovered: '#DDDDDD',
    active: '#CCCCCC',
    icon: <XLogo sx={{ width: 32, height: 32 }} />,
  },
  {
    name: 'Facebook',
    background: '#4267B2',
    hovered: '#567CCA',
    active: '#4366AC',
    icon: <FacebookIcon sx={{ width: 32, height: 32 }} />,
  },
  {
    name: 'LinkedIn',
    background: '#217BB0',
    hovered: '#358EC2',
    active: '#217BB0',
    icon: <LinkedInIcon sx={{ width: 32, height: 32 }} />,
  },
  {
    name: 'Reddit',
    background: '#FF5700',
    hovered: '#FF6617',
    active: '#F65806',
    icon: <RedditIcon sx={{ width: 32, height: 32 }} />,
  },
  {
    name: 'WhatsApp',
    background: '#25D366',
    hovered: '#3EE87D',
    active: '#1DCA5D',
    icon: <WhatsAppIcon sx={{ width: 32, height: 32 }} />,
  },
];

// Email
export const EMAIL_VERIFICATION_DELAY = 60000; // 1 minute
export const EMAIL_LOCAL_STORAGE_ID = 'email';

// Links
export const GMI_LINKS = {
  ReferralProgram: 'https://docs.gonnamakeit.com/docs/about/gmi-referral',
  PrivacyPolicy: 'https://gonnamakeit.com/privacy-policy/',
  GetNRG: 'https://energi.world/get-nrg/',
  DragonDegen: 'https://energistudios.com/dragon-degens-nfts/',
  AirdropDocs: 'https://docs.gonnamakeit.com/docs/airdrop/gmi-airdrop-current',
  Website: 'https://gonnamakeit.com/',
  Webapp: 'https://app.gonnamakeit.com/',
};

export const LEGACY_BRIDGE_URL = 'https://bridge.energi.network';
export const MULTI_CHAIN_BRIDGE_URL = 'https://mbridge.energi.network';
export const METAMASK_URL = 'https://metamask.io/download.html';
export const METAMASK_GUIDE_URL =
  'https://wiki.energi.world/docs/quickstart/getting-started-with-metamask';
export const ZEALY_URL = 'https://zealy.io/cw/energicrew/questboard';
export const REFERRAL_PROGRAM_URL = 'https://ref.gonnamakeit.com';
export const NFT_BRIDGE_URL = 'https://bridge.gonnamakeit.com/';

export const DAILY_ACTIONS = [
  {
    title: 'DAILY CHECK-IN',
    icon: <DailyCheckIcon height="100%" />,
    iconMobile: <DailyCheckIcon height="100%" />,
    to: ROUTES.Dashboard, // This will trigger the daily check-in functionality
  },
  {
    title: 'BOOSTERS',
    icon: <BoostersIcon height="130%" />,
    iconMobile: <BoostersIcon height="170%" />,
    to: ROUTES.Boosters,
  },
  {
    title: 'REFER & EARN',
    icon: <ReferralContestIcon width="50%" height="auto" />,
    iconMobile: <ReferralContestIcon width="60%" height="auto" />,
    to: ROUTES.ReferralProgramContest,
  },
  {
    title: 'REWARDS VAULT',
    icon: <RewardsVaultIcon height="100%" />,
    iconMobile: <RewardsVaultIcon height="100%" />,
    to: ROUTES.RewardsVault,
  },
];

export const COMPETE_EXPLORE = [
  {
    title: 'LEADERBOARDS',
    icon: <LeaderboardsIcon height="100%" />,
    iconMobile: <LeaderboardsIcon height="100%" />,
    to: ROUTES.Leaderboard,
  },
  {
    title: 'EASY WINS',
    icon: <EasyWinsIcon height="100%" />,
    iconMobile: <EasyWinsIcon height="110%" />,
    to: ROUTES.EasyWins,
  },
  {
    title: 'POWER USER PROGRAMS',
    icon: <PowerUserProgramsIcon height="100%" />,
    iconMobile: <PowerUserProgramsIcon height="110%" />,
    to: ROUTES.PowerUserPrograms,
  },
];

// UI
export const AIRDROP_MENUS = [
  {
    title: 'LEADERBOARDS',
    icon: <LeaderboardsIcon height="100%" />,
    iconMobile: <LeaderboardsIcon height="100%" />,
    to: ROUTES.Leaderboard,
  },
  {
    title: 'BOOSTERS',
    icon: <BoostersIcon height="130%" />,
    iconMobile: <BoostersIcon height="130%" />,
    to: ROUTES.Boosters,
  },
  {
    title: 'REFERRAL CONTEST AIRDROP',
    icon: <ReferralContestIcon width="60%" height="auto" />,
    iconMobile: <ReferralContestIcon width="80%" height="auto" />,
    to: ROUTES.ReferralProgramContest,
  },
  // ARCHIVED: Power Tweet Airdrop - Season 11
  // {
  //   title: 'POWER TWEET AIRDROP',
  //   icon: <PowerTweetAirdropIcon height="100%" />,
  //   iconMobile: <PowerTweetAirdropIcon height="100%" />,
  //   to: ROUTES.PowerTweetAirdrop,
  // },
  {
    title: 'TRADER AIRDROP',
    icon: <TraderAirdropIcon height="100%" />,
    iconMobile: <TraderAirdropIcon height="100%" />,
    to: ROUTES.TraderAirdrop,
  },
  {
    title: 'BIDDING & LISTING AIRDROP',
    icon: <NftListingAirdropIcon height="100%" />,
    iconMobile: <NftListingAirdropIcon height="100%" />,
    to: ROUTES.NftListingAirdrop,
  },
  // ARCHIVED: Marketplace Volume Airdrop - Season 11
  // {
  //   title: 'MARKETPLACE VOLUME AIRDROP',
  //   icon: <NftVolumeAirdropIcon height="50px" />,
  //   iconMobile: <NftVolumeAirdropIcon height="50px" />,
  //   to: ROUTES.NftVolumeAirdrop,
  // },
  // ARCHIVED: NFT Hodler Airdrop - Season 12 (will re-add later)
  // {
  //   title: 'NFT HODLER AIRDROP',
  //   icon: <NftAirdropIcon height="100%" />,
  //   iconMobile: <NftAirdropIcon height="100%" />,
  //   to: ROUTES.NftHodler,
  // },
  // ARCHIVED: Liquidity Airdrop - Season 11
  // {
  //   title: 'LIQUIDITY AIRDROP',
  //   icon: <LiquidityAirdropIcon height="100%" />,
  //   iconMobile: <LiquidityAirdropIcon height="100%" />,
  //   to: ROUTES.LiquidityAirdrop,
  // },
  // ARCHIVED Season 14: Tweet To Earn (temporarily removed — easy to bring back)
  // {
  //   title: 'Tweet To Earn',
  //   icon: <XAirdropIcon height="100%" />,
  //   iconMobile: <XAirdropIcon height="100%" />,
  //   to: ROUTES.TweetToEarn,
  // },
  // ARCHIVED: Portfolio Airdrop - Season 12
  // {
  //   title: 'PORTFOLIO AIRDROP',
  //   icon: <NftPortfolioAirdropIcon height="100%" />,
  //   iconMobile: <NftPortfolioAirdropIcon height="100%" />,
  //   to: ROUTES.NftPortfolioAirdrop,
  // },
  // ARCHIVED: Creator Airdrop - Season 11
  // {
  //   title: 'CREATOR AIRDROP',
  //   icon: <CreatorAirdropIcon height="100%" />,
  //   iconMobile: <CreatorAirdropIcon height="100%" />,
  //   to: ROUTES.CreatorAirdrop,
  // },
  {
    title: 'ZEALY AIRDROP',
    icon: <ZealyAirdropIcon height="100%" />,
    iconMobile: <ZealyAirdropIcon height="100%" />,
    to: ROUTES.ZealyAirdrop,
  },
  // HIDDEN: Token Hodler Airdrop (hidden from UI)
  // {
  //   title: 'TOKEN HODLER AIRDROP',
  //   icon: <TokenAirdropIcon height="100%" />,
  //   iconMobile: <TokenAirdropIcon height="100%" />,
  //   to: ROUTES.TokenHodler,
  // },
  // TODO: Uncomment when NFT Bridging Program is active again
  // {
  //   title: 'NFT BRIDGING AIRDROP',
  //   icon: <NftBridingAirdropIcon height="100%" />,
  //   iconMobile: <NftBridingAirdropIcon height="100%" />,
  //   to: ROUTES.NftBridgeAirdrop,
  // },
  /*{
    title: 'MEME CREATOR AIRDROP',
    icon: <MemeCreatorIcon height="100%" />,
    to: ROUTES.MemeCreatorAirdrop,
  },*/
];

export const EASY_WINS_MENUS = [
  // ARCHIVED Season 14: Tweet To Earn (temporarily removed — easy to bring back)
  // {
  //   title: 'TWEET TO EARN',
  //   subtitle: 'Earn rewards by tweeting about GMI',
  //   icon: <XAirdropIcon height="50px" />,
  //   iconMobile: <XAirdropIcon height="50px" />,
  //   to: ROUTES.TweetToEarn,
  // },
  {
    title: 'REFERRAL CONTEST',
    subtitle: 'Refer friends and earn rewards',
    icon: <ReferralContestIcon width="30%" height="auto" />,
    iconMobile: <ReferralContestIcon width="50%" height="auto" />,
    to: ROUTES.ReferralProgramContest,
  },
  // ARCHIVED: Power Tweet - Season 11
  // {
  //   title: 'POWER TWEET',
  //   subtitle: 'Powerful tweets for big rewards',
  //   icon: <PowerTweetAirdropIcon height="100%" />,
  //   iconMobile: <PowerTweetAirdropIcon height="100%" />,
  //   to: ROUTES.PowerTweetAirdrop,
  // },
  // ARCHIVED: Marketplace Volume - Season 11
  // {
  //   title: 'MARKETPLACE VOLUME',
  //   subtitle: 'Earn for past volume on other marketplaces',
  //   icon: <NftVolumeAirdropIcon height="50px" />,
  //   iconMobile: <NftVolumeAirdropIcon height="50px" />,
  //   to: ROUTES.NftVolumeAirdrop,
  // },
  // HIDDEN: Token Hodler (hidden from UI)
  // {
  //   title: 'TOKEN HODLER',
  //   subtitle: 'Hold tokens to earn rewards',
  //   icon: <TokenAirdropIcon height="100%" />,
  //   iconMobile: <TokenAirdropIcon height="100%" />,
  //   to: ROUTES.TokenHodler,
  // },
  // ARCHIVED: NFT Hodler - Season 12 (will re-add later)
  // {
  //   title: 'NFT HODLER',
  //   subtitle: 'Hold NFTs to earn rewards',
  //   icon: <NftAirdropIcon height="100%" />,
  //   iconMobile: <NftAirdropIcon height="100%" />,
  //   to: ROUTES.NftHodler,
  // },
];

export const POWER_USER_MENUS = [
  {
    title: 'MINTING AIRDROP',
    subtitle: 'Mint LP Bonds and earn',
    icon: <Cash2Icon width="100%" height="100%" />,
    iconMobile: <Cash2Icon width="100%" height="100%" />,
    to: ROUTES.MintingAirdrop,
  },
  {
    title: 'TRADER AIRDROP',
    subtitle: 'Trade and earn based on volume',
    icon: <TraderAirdropIcon height="100%" />,
    iconMobile: <TraderAirdropIcon height="100%" />,
    to: ROUTES.TraderAirdrop,
  },
  {
    title: 'BIDDING AND LISTING AIRDROP',
    subtitle: 'List and bid on NFTs',
    icon: <NftListingAirdropIcon height="100%" />,
    iconMobile: <NftListingAirdropIcon height="100%" />,
    to: ROUTES.NftListingAirdrop,
  },
  // ARCHIVED: Liquidity Airdrop - Season 11
  // {
  //   title: 'LIQUIDITY AIRDROP',
  //   subtitle: 'Provide liquidity to pools',
  //   icon: <LiquidityAirdropIcon height="100%" />,
  //   iconMobile: <LiquidityAirdropIcon height="100%" />,
  //   to: ROUTES.LiquidityAirdrop,
  // },
  // ARCHIVED: Portfolio Airdrop - Season 12
  // {
  //   title: 'PORTFOLIO AIRDROP',
  //   subtitle: 'Diverse portfolio rewards',
  //   icon: <NftPortfolioAirdropIcon height="100%" />,
  //   iconMobile: <NftPortfolioAirdropIcon height="100%" />,
  //   to: ROUTES.NftPortfolioAirdrop,
  // },
  // ARCHIVED: Creator Airdrop - Season 11
  // {
  //   title: 'CREATOR AIRDROP',
  //   subtitle: 'Create content and earn',
  //   icon: <CreatorAirdropIcon height="100%" />,
  //   iconMobile: <CreatorAirdropIcon height="100%" />,
  //   to: ROUTES.CreatorAirdrop,
  // },
  {
    title: 'ZEALY AIRDROP',
    subtitle: 'Complete tasks on Zealy',
    icon: <ZealyAirdropIcon height="100%" />,
    iconMobile: <ZealyAirdropIcon height="100%" />,
    to: ROUTES.ZealyAirdrop,
  },
];

export const TOKEN_ICONS = {
  NRG: <NRGTokenIcon width={22} height={22} />,
  ETH: <ETHTokenIcon width={22} height={22} />,
  USDT: <USDTTokenIcon width={22} height={22} />,
  USDC: <USDCTokenIcon width={22} height={22} />,
  DAI: <DAITokenIcon width={22} height={22} />,
  PEPE: <PEPETokenIcon width={22} height={22} />,
};

// Airdrop
export const SEASONS = {
  1: {
    start: 1752469200000, // UTC Sunday, July 13, 2025 2:00:00 PM
    end: 1757847600000, // UTC Friday, September 12, 2025 2:00:00 PM
  },
  2: {
    start: 1720080000000, // UTC Thursday, July 4, 2024 8:00:00 AM
    end: 1725436800000, // UTC Wednesday, September 4, 2024 8:00:00 AM
  },
  3: {
    start: 1725580800000, // UTC Friday, September 6, 2024 12:00:00 AM
    end: 1727740800000, // UTC Tuesday, October 1, 2024 12:00:00 AM
  },
  4: {
    start: 1728316800000, // UTC Monday, October 7, 2024 4:00:00 PM
    end: 1730908800000, // UTC Thursday, November 6, 2024 4:00:00 PM
  },
  5: {
    start: 1731427200000, // UTC Tuesday, November 12, 2024 4:00:00 PM
    end: 1735315200000, // UTC Friday, December 27, 2024 4:00:00 PM
  },
  6: {
    start: 1735743600000, // UTC Wednesday, January 1, 2025 3:00:00 PM
    end: 1738368000000, // UTC Saturday, February 1, 2025 12:00:00 AM
  },
  7: {
    start: 1738605600000, // UTC Monday, February 3, 2025 6:00:00 PM
    end: 1741200000000, // UTC Wednesday, March 5, 2025 6:40:00 PM
  },
  8: {
    start: 1741410000000, // UTC Saturday, March 8, 2025 5:00:00 AM
    end: 1744100000000, // UTC Tuesday, April 8, 2025 8:13:20 AM
  },
  9: {
    start: 1744248600000, // UTC Thursday, April 10, 2025 1:30:00 AM
    end: 1746850000000, // UTC Saturday, May 10, 2025 4:06:40 AM
  },
  10: {
    start: 1747144800000, // UTC Tuesday, May 13, 2025 2:00:00 PM
    end: 1752328800000, // UTC Saturday, July 12, 2025 2:00:00 PM
  },
  11: {
    start: 1754802000000, // Sun Aug 10 2025 05:00:00 GMT+0000 (12 noon Bangkok Time) - Season 1 Wave 2
    end: 1760072400000, // Fri Oct 10 2025 05:00:00 GMT+0000
  },
  12: {
    start: 1764777600000, // Mon Dec 4 2025 16:00:00 GMT+0000 - Season 2 Wave 2
    end: 1770220800000, // Mon Feb 4 2026 16:00:00 GMT+0000
  },
  13: {
    start: 1771257600000, // Thu Feb 17 2026 16:00:00 GMT+0000 - Season 3 Wave 2
    end: 1776355200000, /// April 16, 2026 GMT+8
  },
  14: {
    start: 1777219200000, // Sun Apr 26 2026 16:00:00 GMT+0000 - Season 4 Wave 2
    end: 1785081600000, // Sun Jul 26 2026 16:00:00 GMT+0000
  },
  15: {
    start: 1817190846000, // TEMP HALT: Mon Aug 2 2027 ~07:14 GMT+0000 — S15 paused; real start = 1786204800000 (Sat Aug 8 2026 16:00 UTC) - Season 5 Wave 2
    end: 1825142579000, // Sun Nov 8 2027 16:00:00 GMT+0000
  },
};

export const AIRDROP_SEASON = 15;
export const VAULT_SEASON = 14;

// Wave system for season display
export const getSeasonDisplay = (season) => {
  if (season <= 10) {
    return `Wave 1 Season ${season}`;
  }

  const wave = Math.ceil((season - 10) / 10) + 1;
  const seasonInWave = ((season - 11) % 10) + 1;
  return `Wave ${wave} Season ${seasonInWave}`;
};

// Helper for current season display
export const getCurrentSeasonDisplay = () => getSeasonDisplay(AIRDROP_SEASON);
export const AIRDROP_GMI_REWARDS = {
  referralContest: 1, // 2M GMI - Refer and Earn Airdrop
  // ARCHIVED Season 11: powerTweet: 0.5, // 500K GMI - Power Tweet Airdrop
  trader: 1, // 1M GMI - Trader Airdrop
  listing: 1, // 1M GMI - Bidding and Listing Airdrop
  // ARCHIVED Season 11: marketplaceVolume: 0.5, // 500K GMI - Marketing Volume Airdrop
  tokenHodler: 0.5, // 500K GMI - Token Hodler Airdrop
  nftHodler: 1, // 1M GMI - NFT Hodler Airdrop (when re-added for Season 12)
  // ARCHIVED Season 11: liquidity: 1, // 1M GMI - Liquidity Airdrop
  // ARCHIVED Season 14: x: 1, // 1M GMI - Tweet to Earn Airdrop (temporarily removed — easy to bring back)
  // ARCHIVED Season 12: portfolio: 1, // 1M GMI - Portfolio Airdrop
  minting: 1, // 1M GMI - Minting Airdrop
  // ARCHIVED Season 11: creator: 0.5, // 500K GMI - Creator Airdrop
  zealy: 0.5, // 500K GMI - Zealy Airdrop
  // bridging: 0,         // NOT DOING NFT Bridging Program this season
};
export const TOP_10_GMI_REWARDS = 420_000;
export const AIRDROP_START_DATE = new Date(SEASONS[AIRDROP_SEASON].start);
export const AIRDROP_FINISH_DATE = new Date(SEASONS[AIRDROP_SEASON].end);

export const CURRENT_REWARD_SEASON = 0;

export const RP_X_SHARE_MESSAGE = `Have you joined the GMI Airdrop yet?

🚀 Earn big rewards with 0 investment, juicy bonuses, and a 3-level referral system!

Just by referring others your rewards will stack fast! Use my ref code for 30% bonus👇`;

export const POWER_TWEET_SHARE_MESSAGE = `🚀 @GonnaMakeitNFTs ${getCurrentSeasonDisplay()} is LIVE! Over 150M GMI already distributed—now it’s time for YOU to claim your share! 💎

With zero investment, quick bonuses & a 3-level referral system, earning big has never been easier!

Don’t miss out—join now! 👇`;

export const POWER_TWEET_REWARD_MESSAGE = (totalGMI) =>
  totalGMI === 0
    ? `💸 11,000,000 $GMI distributed to ${getSeasonDisplay(
        CURRENT_REWARD_SEASON,
      )} participants! with @GonnaMakeItNFTs! Earn big rewards with 0 investment, quick bonuses, and a 3-level referral system!

Even if you miss base points, referrals can stack rewards fast. Use my ref code for 30% bonus👇`
    : `🚀 I scored ${totalGMI.toLocaleString()} GMI in ${getSeasonDisplay(
        CURRENT_REWARD_SEASON,
      )}! 💎 With @GonnaMakeItNFTs gain big rewards with 0 investment, quick bonuses, and a 3-level referral system!

Just by inviting others, referral rewards can stack rewards fast. Use my ref code for 30% bonus👇
`;

export const AIRDROP_DOCS_LINK = 'https://docs.gonnamakeit.com/docs/airdrop/gmi-airdrop-current';

export const BRIDGED_TOKENS = ['ETH', 'USDT', 'USDC', 'DAI', 'PEPE'];
export const LIQUIDITY_PAIRS = {
  Energi: [
    {
      address: '0xb8477E82CbFB664B465979A7819b7F640880277c',
      token0: 'NRG',
      token1: 'ETH',
      token1Address: '0x78B050d981d7f6E019Bf6E361D0d1167de6B19dA',
    },
    {
      address: '0x3F0a1D7C138C18CdB4B9A51Ec932d217e7b80942',
      token0: 'NRG',
      token1: 'USDT',
      token1Address: '0x470075Cf46e6132aaD78C40a1BE53a494b05E831',
    },
    {
      address: '0xf3963f014b8525D7B79D2491aD40B83fB37CCC63',
      token0: 'NRG',
      token1: 'USDC',
      token1Address: '0xFFD7510ca0a3279c7a5F50018A26c21d5bc1DBcF',
    },
    {
      address: '0x5Cc8B3D89AE2cA30A08b6697E33606FC3437d392',
      token0: 'NRG',
      token1: 'DAI',
      token1Address: '0x0ee5893f434017d8881750101Ea2F7c49c0eb503',
    },
    {
      address: '0xacA8dC617f4828693FdC22240b1530700caFE4c3',
      token0: 'NRG',
      token1: 'PEPE',
      token1Address: '0x52B16632A9ed3977D7D701108bD548Ce693b610c',
    },
  ],
  Ethereum: [
    {
      token0: 'NRG',
      token1: 'ETH',
      address: '0xd2624380a006220574c9e75083490b042e71ee42',
      token1Address: '0x1416946162B1C2c871A73B07E932D2fB6C932069',
    },
  ],
};
export const LIQUIDITY_POOL_LINKS = {
  Energi: 'https://app.energiswap.exchange/#/add/',
  Ethereum: 'https://app.uniswap.org/add/',
};

export const LEADERBOARDS = [
  // ARCHIVED Season 14: Tweet To Earn Leaderboard (temporarily removed — easy to bring back)
  // {
  //   key: 'x',
  //   value: 'Tweet To Earn Leaderboard',
  //   menuTitle: 'X',
  //   row: XDataRow,
  //   headers: [
  //     { id: 'rank', label: 'Rank' },
  //     { id: 'twitterHandle', label: 'Twitter Handle', align: 'left' },
  //     { id: 'tweets', label: 'Tweets', hideOnMobile: true },
  //     { id: 'views', label: 'Views', hideOnMobile: true },
  //     { id: 'score', label: 'Score (Lvl | XP)' },
  //   ],
  // },
  {
    key: 'referralContest',
    value: 'Refer and Earn Airdrop Leaderboard',
    menuTitle: 'Refer and Earn Airdrop',
    row: ReferralContestDataRow,
    headers: [
      { id: 'rank', label: 'Rank' },
      { id: 'account', label: 'Account', align: 'left' },
      { id: 'platinum', label: 'Score (Platinum)' },
    ],
  },
  {
    key: 'minting',
    value: 'Minting Airdrop Leaderboard',
    menuTitle: 'Minting Airdrop',
    row: MintingDataRow,
    headers: [
      { id: 'rank', label: 'Rank' },
      { id: 'wallet', label: 'Wallet Address', align: 'left' },
      { id: 'score', label: 'Score (Sapphires)' },
    ],
  },
  // ARCHIVED: Power Tweet Airdrop Leaderboard - Season 11
  // {
  //   key: 'powerTweet',
  //   value: 'Power Tweet Airdrop Leaderboard',
  //   menuTitle: 'Power Tweet Airdrop',
  //   row: PowerTweetDataRow,
  //   headers: [
  //     { id: 'rank', label: 'Rank' },
  //     { id: 'address', label: 'Wallet Address', align: 'left' },
  //     { id: 'score', label: 'Score (Gold)' },
  //   ],
  // },
  {
    key: 'trader',
    value: 'Trader Airdrop Leaderboard',
    menuTitle: 'Trader Airdrop',
    row: TraderDataRow,
    headers: [
      { id: 'rank', label: 'Rank' },
      { id: 'wallet', label: 'Wallet Address', align: 'left' },
      { id: 'volume', label: 'Total Volume', hideOnMobile: true, align: 'right' },
      { id: 'score', label: 'Score (Topaz)', align: 'right' },
    ],
  },
  {
    key: 'listing',
    value: 'Bidding & Listing Airdrop Leaderboard',
    menuTitle: 'Bidding & Listing Airdrop',
    row: ListingDataRow,
    headers: [
      { id: 'rank', label: 'Rank' },
      { id: 'wallet', label: 'Wallet Address', align: 'left' },
      { id: 'score', label: 'Score (Mana)' },
    ],
  },
  // ARCHIVED: Marketplace Volume Airdrop Leaderboard - Season 11
  // {
  //   key: 'nftVolume',
  //   value: 'Marketplace Vol Airdrop Leaderboard',
  //   menuTitle: 'Marketplace Vol Airdrop',
  //   row: NftVolumeDataRow,
  //   headers: [
  //     { id: 'rank', label: 'Rank' },
  //     { id: 'wallet', label: 'Wallet Address', align: 'left' },
  //     { id: 'score', label: 'Score (Diamonds)' },
  //   ],
  // },
  // ARCHIVED: NFT Hodler Leaderboard - Season 12 (will re-add later)
  // {
  //   key: 'nft',
  //   value: 'NFT Hodler Airdrop Leaderboard',
  //   menuTitle: 'NFT Hodler Airdrop',
  //   row: NftHodlerDataRow,
  //   headers: [
  //     { id: 'rank', label: 'Rank' },
  //     { id: 'wallet', label: 'Wallet Address', align: 'left' },
  //     { id: 'score', label: 'Score (Rubies)' },
  //   ],
  // },
  // ARCHIVED: Liquidity Airdrop Leaderboard - Season 11
  // {
  //   key: 'liquidity',
  //   value: 'Liquidity Airdrop Leaderboard',
  //   menuTitle: 'Liquidity',
  //   row: LiquidityDataRow,
  //   headers: [
  //     { id: 'rank', label: 'Rank' },
  //     { id: 'wallet', label: 'Wallet Address', align: 'left' },
  //     { id: 'liquidity', label: 'Total Liquidity', hideOnMobile: true },
  //     { id: 'score', label: 'Score (Sapphires)' },
  //   ],
  // },
  // ARCHIVED: Portfolio Airdrop Leaderboard - Season 12
  // {
  //   key: 'portfolio',
  //   value: 'Portfolio Airdrop Leaderboard',
  //   menuTitle: 'Portfolio Airdrop',
  //   row: NftPortfolioDataRow,
  //   headers: [
  //     { id: 'rank', label: 'Rank' },
  //     { id: 'wallet', label: 'Wallet Address', align: 'left' },
  //     { id: 'score', label: 'Score (Emeralds)' },
  //   ],
  // },
  // ARCHIVED: Creator Airdrop Leaderboard - Season 11
  // {
  //   key: 'creator',
  //   value: 'Creator Airdrop Leaderboard',
  //   menuTitle: 'Creator Airdrop',
  //   row: CreatorDataRow,
  //   headers: [
  //     { id: 'rank', label: 'Rank' },
  //     { id: 'collection', label: 'Collection Name', align: 'left' },
  //     { id: 'volume', label: 'Total Volume', hideOnMobile: true, align: 'right' },
  //     { id: 'score', label: 'Score (Quartz)', align: 'right' },
  //   ],
  // },
  {
    key: 'zealy',
    value: 'Zealy Airdrop Leaderboard',
    menuTitle: 'Zealy Airdrop',
    row: ZealyDataRow,
    headers: [
      { id: 'rank', label: 'Rank' },
      { id: 'username', label: 'Username', align: 'left' },
      { id: 'score', label: 'Score (Pearls)' },
    ],
  },
  // HIDDEN: Token Hodler Airdrop Leaderboard (hidden from UI)
  // {
  //   key: 'token',
  //   value: 'Token Hodler Airdrop Leaderboard',
  //   menuTitle: 'Token Hodler Airdrop',
  //   row: TokenHodlerDataRow,
  //   headers: [
  //     { id: 'rank', label: 'Rank' },
  //     { id: 'wallet', label: 'Wallet Address', align: 'left' },
  //     { id: 'score', label: 'Score (Aether)' },
  //   ],
  // },
];

// NFT_HODLER array has been replaced by dynamic configuration
// See src/constants/nftConfig.js for the new centralized approach
// TOKEN_HODLER array has been replaced by dynamic configuration
// See src/constants/tokenConfig.js for the new centralized approach
export const TOKEN_HODLER_REMOVED = [
  {
    name: 'Ethereum',
    title: 'ETH Hodler Airdrop',
    pointsTitle: [
      'ETH Hodler Base Aether:',
      'ETH Hodler Booster Aether:',
      'ETH Hodler Referral Aether:',
      'ETH Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Uniswap',
    title: 'Uniswap Hodler Airdrop',
    pointsTitle: [
      'Uniswap Hodler Base Aether:',
      'Uniswap Hodler Booster Aether:',
      'Uniswap Hodler Referral Aether:',
      'Uniswap Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'USDC',
    title: 'USDC Hodler Airdrop',
    pointsTitle: [
      'USDC Hodler Base Aether:',
      'USDC Hodler Booster Aether:',
      'USDC Hodler Referral Aether:',
      'USDC Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Pepe',
    title: 'PEPE Hodler Airdrop',
    pointsTitle: [
      'PEPE Hodler Base Aether:',
      'PEPE Hodler Booster Aether:',
      'PEPE Hodler Referral Aether:',
      'PEPE Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Shiba Inu',
    title: 'SHIB Hodler Airdrop',
    pointsTitle: [
      'SHIB Hodler Base Aether:',
      'SHIB Hodler Booster Aether:',
      'SHIB Hodler Referral Aether:',
      'SHIB Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Mog Coin',
    title: 'MOG Hodler Airdrop',
    pointsTitle: [
      'MOG Hodler Base Aether:',
      'MOG Hodler Booster Aether:',
      'MOG Hodler Referral Aether:',
      'MOG Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Chain Link',
    title: 'ChainLink Hodler Airdrop',
    pointsTitle: [
      'ChainLink Hodler Base Aether:',
      'ChainLink Hodler Booster Aether:',
      'ChainLink Hodler Referral Aether:',
      'ChainLink Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Balancer',
    title: 'Balancer Hodler Airdrop',
    pointsTitle: [
      'Balancer Hodler Base Aether:',
      'Balancer Hodler Booster Aether:',
      'Balancer Hodler Referral Aether:',
      'Balancer Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Decentraland',
    title: 'Decentraland Hodler Airdrop',
    pointsTitle: [
      'Decentraland Hodler Base Aether:',
      'Decentraland Hodler Booster Aether:',
      'Decentraland Hodler Referral Aether:',
      'Decentraland Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Aave Token',
    title: 'AAVE Hodler Airdrop',
    pointsTitle: [
      'AAVE Hodler Base Aether:',
      'AAVE Hodler Booster Aether:',
      'AAVE Hodler Referral Aether:',
      'AAVE Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Compound',
    title: 'Compound Hodler Airdrop',
    pointsTitle: [
      'Compound Hodler Base Aether:',
      'Compound Hodler Booster Aether:',
      'Compound Hodler Referral Aether:',
      'Compound Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Lido DAO Token',
    title: 'Lido Hodler Airdrop',
    pointsTitle: [
      'Lido Hodler Base Aether:',
      'Lido Hodler Booster Aether:',
      'Lido Hodler Referral Aether:',
      'Lido Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Curve DAO Token',
    title: 'Curve Hodler Airdrop',
    pointsTitle: [
      'Curve Hodler Base Aether:',
      'Curve Hodler Booster Aether:',
      'Curve Hodler Referral Aether:',
      'Curve Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Blast',
    title: 'BLAST Hodler Airdrop',
    pointsTitle: [
      'BLAST Hodler Base Aether:',
      'BLAST Hodler Booster Aether:',
      'BLAST Hodler Referral Aether:',
      'BLAST Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Blur',
    title: 'BLUR Hodler Airdrop',
    pointsTitle: [
      'BLUR Hodler Base Aether:',
      'BLUR Hodler Booster Aether:',
      'BLUR Hodler Referral Aether:',
      'BLUR Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Trump',
    title: 'Trump Hodler Airdrop',
    pointsTitle: [
      'Trump Hodler Base Aether:',
      'Trump Hodler Booster Aether:',
      'Trump Hodler Referral Aether:',
      'Trump Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Turbo',
    title: 'Turbo Hodler Airdrop',
    pointsTitle: [
      'Turbo Hodler Base Aether:',
      'Turbo Hodler Booster Aether:',
      'Turbo Hodler Referral Aether:',
      'Turbo Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Floki',
    title: 'Floki Hodler Airdrop',
    pointsTitle: [
      'Floki Hodler Base Aether:',
      'Floki Hodler Booster Aether:',
      'Floki Hodler Referral Aether:',
      'Floki Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'The Balkan Dwarf',
    title: 'KeKec Hodler Airdrop',
    pointsTitle: [
      'KeKec Hodler Base Aether:',
      'KeKec Hodler Booster Aether:',
      'KeKec Hodler Referral Aether:',
      'KeKec Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'LooksRare Token',
    title: 'LooksRare Hodler Airdrop',
    pointsTitle: [
      'LooksRare Hodler Base Aether:',
      'LooksRare Hodler Booster Aether:',
      'LooksRare Hodler Referral Aether:',
      'LooksRare Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'X2Y2Token',
    title: 'X2Y2 Hodler Airdrop',
    pointsTitle: [
      'X2Y2 Hodler Base Aether:',
      'X2Y2 Hodler Booster Aether:',
      'X2Y2 Hodler Referral Aether:',
      'X2Y2 Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Ethereum Name Service',
    title: 'Ens Hodler Airdrop',
    pointsTitle: [
      'Ens Hodler Base Aether:',
      'Ens Hodler Booster Aether:',
      'Ens Hodler Referral Aether:',
      'Ens Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Gnosis',
    title: 'Gnosis Hodler Airdrop',
    pointsTitle: [
      'Gnosis Hodler Base Aether:',
      'Gnosis Hodler Booster Aether:',
      'Gnosis Hodler Referral Aether:',
      'Gnosis Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Pooh',
    title: 'Pooh Hodler Airdrop',
    pointsTitle: [
      'Pooh Hodler Base Aether:',
      'Pooh Hodler Booster Aether:',
      'Pooh Hodler Referral Aether:',
      'Pooh Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'MongCoin',
    title: 'MongCoin Hodler Airdrop',
    pointsTitle: [
      'MongCoin Hodler Base Aether:',
      'MongCoin Hodler Booster Aether:',
      'MongCoin Hodler Referral Aether:',
      'MongCoin Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Maker',
    title: 'Maker Hodler Airdrop',
    pointsTitle: [
      'Maker Hodler Base Aether:',
      'Maker Hodler Booster Aether:',
      'Maker Hodler Referral Aether:',
      'Maker Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Graph Token',
    title: 'The Graph Hodler Airdrop',
    pointsTitle: [
      'The Graph Hodler Base Aether:',
      'The Graph Hodler Booster Aether:',
      'The Graph Hodler Referral Aether:',
      'The Graph Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'SAND',
    title: 'Sandbox Hodler Airdrop',
    pointsTitle: [
      'Sandbox Hodler Base Aether:',
      'Sandbox Hodler Booster Aether:',
      'Sandbox Hodler Referral Aether:',
      'Sandbox Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'SushiToken',
    title: 'Sushi Hodler Airdrop',
    pointsTitle: [
      'Sushi Hodler Base Aether:',
      'Sushi Hodler Booster Aether:',
      'Sushi Hodler Referral Aether:',
      'Sushi Hodler Total Aether:',
    ],
    values: [null, null, null, null],
  },
];
export const NFT_VOLUME = [
  {
    name: 'opensea',
    title: 'OpenSea Volume Airdrop',
    pointsTitle: [
      'OpenSea Volume Base Diamonds:',
      'OpenSea Volume Booster Diamonds:',
      'OpenSea Volume Referral Diamonds:',
      'OpenSea Volume Total Diamonds:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'blur',
    title: 'Blur Volume Airdrop',
    pointsTitle: [
      'Blur Volume Base Diamonds:',
      'Blur Volume Booster Diamonds:',
      'Blur Volume Referral Diamonds:',
      'Blur Volume Total Diamonds:',
    ],
    values: [null, null, null, null],
  },
];
export const LEADERBOARD_RANKING_REWARDS = [
  {
    rank: '1st Place',
    reward: '100K',
    number: '100,000',
  },
  {
    rank: '2nd Place',
    reward: '70K',
    number: '70,000',
  },
  {
    rank: '3rd Place',
    reward: '60K',
    number: '60,000',
  },
  {
    rank: '4th Place',
    reward: '50K',
    number: '50,000',
  },
  {
    rank: '5th Place',
    reward: '40K',
    number: '40,000',
  },
  {
    rank: '6th Place',
    reward: '30K',
    number: '30,000',
  },
  {
    rank: '7th Place',
    reward: '25K',
    number: '25,000',
  },
  {
    rank: '8th Place',
    reward: '20K',
    number: '20,000',
  },
  {
    rank: '9th Place',
    reward: '15K',
    number: '15,000',
  },
  {
    rank: '10th Place',
    reward: '10K',
    number: '10,000',
  },
];
export const END_SEASON_POINTS = [
  // ARCHIVED Season 14: Tweet To Earn end-season points (temporarily removed — easy to bring back)
  // {
  //   name: 'X',
  //   title: 'Tweet To Earn',
  //   pointsTitle: [
  //     'Tweet To Earn Base Points:',
  //     'Tweet To Earn Booster Points:',
  //     'Tweet To Earn Referral Points:',
  //     'Tweet To Earn Total Points:',
  //     'GMI Earned:',
  //   ],
  //   values: [null, null, null, null],
  // },
  {
    name: 'Liquidity',
    title: 'Liquidity Airdrop',
    pointsTitle: [
      'Liquidity Airdrop Base Points:',
      'Liquidity Airdrop Booster Points:',
      'Liquidity Airdrop Referral Points:',
      'Liquidity Airdrop Total Points:',
      'GMI Earned:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Trader',
    title: 'Trader Airdrop',
    pointsTitle: [
      'Trader Airdrop Base Points:',
      'Trader Airdrop Booster Points:',
      'Trader Airdrop Referral Points:',
      'Trader Airdrop Total Points:',
      'GMI Earned:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Creator',
    title: 'Creator Airdrop',
    pointsTitle: [
      'Creator Airdrop Base Points:',
      'Creator Airdrop Booster Points:',
      'Creator Airdrop Referral Points:',
      'Creator Airdrop Total Points:',
      'GMI Earned:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Token Hodler',
    title: 'Token Hodler Airdrop',
    pointsTitle: [
      'Token Hodler Base Points:',
      'Token Hodler Booster Points:',
      'Token Hodler Referral Points:',
      'Token Hodler Total Points:',
      'GMI Earned:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'NFT Hodler',
    title: 'NFT Hodler Airdrop',
    pointsTitle: [
      'NFT Hodler Base Points:',
      'NFT Hodler Booster Points:',
      'NFT Hodler Referral Points:',
      'NFT Hodler Total Points:',
      'GMI Earned:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'NFT Volume',
    title: 'NFT Volume Airdrop',
    pointsTitle: [
      'NFT Volume Base Points:',
      'NFT Volume Booster Points:',
      'NFT Volume Referral Points:',
      'NFT Volume Total Points:',
      'GMI Earned:',
    ],
    values: [null, null, null, null],
  },
  {
    name: 'Zealy',
    title: 'Zealy Airdrop',
    pointsTitle: [
      'Zealy Airdrop Base Points:',
      'Zealy Airdrop Booster Points:',
      'Zealy Airdrop Referral Points:',
      'Zealy Airdrop Total Points:',
      'GMI Earned:',
    ],
    values: [null, null, null, null],
  },
];

export const MAXIMUM_BOOSTER_PERCENTAGE = 370;

// Other
export const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export const CHART_TIME_FRAMES = {
  ALL: () => new Date(0),
  '1Y': () => {
    const today = new Date();
    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    return oneYearAgo;
  },
  '3M': () => {
    const today = new Date();
    const threeMonthsAgo = new Date(today);
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    return threeMonthsAgo;
  },
  '1M': () => {
    const today = new Date();
    const monthAgo = new Date(today);
    monthAgo.setMonth(today.getMonth() - 1);
    return monthAgo;
  },
};

export const CHART_DEFAULT_TIME_FRAME = 'ALL';
export const AIRDROP_STARTING_POINT_FOR_CHART = new Date('2024-06-01');
